<template>
  <div class="settlement-banner">
    <div class="banner-header">
      <div class="banner-content">
        <v-icon small color="#378595" class="mr-2">mdi-clock-outline</v-icon>
        <span>
          <strong>Settlement diproses bertahap:</strong> 5 batch/hari untuk merchant H+0, 1 batch/hari (setelah EOD) untuk merchant H+1. Mengikuti Waktu Indonesia Barat (WIB).
        </span>
      </div>
      <button
        class="toggle-btn"
        type="button"
        @click="toggleExpand"
        @keydown.enter="toggleExpand"
      >
        {{ expanded ? 'Tutup jadwal lengkap' : 'Lihat jadwal lengkap' }}
        <v-icon small color="#378595">{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </button>
    </div>

    <div class="banner-detail-wrapper" :style="{ maxHeight: expanded ? '400px' : '0px' }">
      <div class="banner-detail">
        <div class="detail-header">
          <v-icon small color="#378595" class="mr-1">mdi-clock-outline</v-icon>
          <strong>Jadwal Batch Settlement (WIB)</strong>
          <v-btn icon small class="close-btn" @click="toggleExpand">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="batch-list">
          <div class="batch-item">
            <span class="batch-label">Batch 1</span>
            <span class="batch-time">· Transaksi 00.00–09.59 → Dana cair <strong>11.00</strong></span>
          </div>
          <div class="batch-item">
            <span class="batch-label">Batch 2</span>
            <span class="batch-time">· Transaksi 10.00–13.59 → Dana cair <strong>15.00</strong></span>
          </div>
          <div class="batch-item">
            <span class="batch-label">Batch 3</span>
            <span class="batch-time">· Transaksi 14.00–17.29 → Dana cair <strong>19.30</strong></span>
          </div>
          <div class="batch-item">
            <span class="batch-label">Batch 4</span>
            <span class="batch-time">· Transaksi 17.30–21.59 → Dana cair <strong>04.00</strong> <strong class="text-warning">(H+1)</strong></span>
          </div>
          <div class="batch-item">
            <span class="batch-label">Batch 5</span>
            <span class="batch-time">· Transaksi 22.00–23.59 → Dana cair <strong>04.00</strong> <strong class="text-warning">(H+1)</strong></span>
          </div>
        </div>

        <div class="banner-footer">
          <v-icon x-small color="#378595" class="mr-1">mdi-information</v-icon>
          Seluruh waktu di atas mengikuti Waktu Indonesia Barat (WIB).
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettlementInfoBanner",
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    }
  }
};
</script>

<style scoped>
.settlement-banner {
  background-color: #f5f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.banner-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.banner-content {
  display: flex;
  align-items: flex-start;
  flex: 1;
  font-size: 14px;
  color: #333;
}

.toggle-btn {
  background: transparent;
  border: none;
  color: #378595;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.toggle-btn:hover {
  text-decoration: underline;
}

.banner-detail-wrapper {
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}

.banner-detail {
  border-top: 1px solid #e0e0e0;
  padding: 16px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}

.detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
}

.close-btn {
  margin-left: auto;
}

.batch-list {
  margin-left: 8px;
}

.batch-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
  font-size: 14px;
}

.batch-label {
  color: #378595;
  font-weight: 500;
  min-width: 60px;
}

.batch-label.batch-h1 {
  color: #e67e22;
}

.batch-time {
  color: #555;
}

.text-warning {
  color: #e67e22;
}

.banner-footer {
  margin-top: 16px;
  padding: 8px 12px;
  background-color: #f0f7f9;
  border-left: 3px solid #378595;
  font-size: 13px;
  color: #555;
  display: flex;
  align-items: center;
}
</style>
